import type { MaskitoOptions } from '@maskito/core';

/* Using this instead of Reefer's dateRegex since dateRegex only requires 2 digits for the year */
export const BIRTHDAY_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;

export const BIRTH_DATE_MASK: MaskitoOptions = {
  mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
};
